// Helper: determines whether a popup variant should apply scaling styles/behavior
// Centralizing this allows reuse and keeps component lean.

export const isScalableVariant = (variant: string | undefined): boolean => {
	if (!variant) {
		return false;
	}
	return [
		"drip-offer",
		"drip-offer-reward",
		"endless-offer-reward-collected",
		"daily-login-streak-loyalty-points",
		"drip-offer-end",
		"drip-offer-missed-event",
		"bouncy-chest-reward-collected",
		"loyalty-points-info",
		"cgg-new-tier",
		"cgg-event-completed",
		"cgg-eligibility-tools",
		"cgg-not-enough-club-members",
		"cgg-not-yet-contributed",
		"cgg-more-info",
		"pb-pbftue-v2",
		"pb-pbftue-v3",
		"sign-up-incentive-reward",
		"rewarding-deeplink-reward",
		"pb-v3-select-event",
		"pb-v3-tier-complete",
		"pb-v3-rewards-uncollected",
		"pb-v3-cycle-complete",
		"first-purchase"
	].some(
		(key) =>
			variant === key ||
			variant.includes("pb-v3-club-change") ||
			variant.includes("single-item-info") ||
			variant.includes("bundle-up") ||
			variant.includes("rebate") ||
			variant.includes("friend-shop") ||
			variant.includes("friend-invite") ||
			variant.includes("pwa") ||
			variant.includes("push") ||
			variant.includes("tutorial")
	);
};

export default isScalableVariant;
